import type { ReactNode } from 'react';

export const symbol_water_ph: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M410-868q5 2 10 6 45 41 97.5 92t97 109Q659-603 689-540t31 129q0 13-9 22t-22 9q-12 0-20-9t-9-21q-2-48-21.5-93T593-588q-33-50-81.5-103T400-800Q273-688 206.5-587.5T140-408q0 97 56.5 171T350-145q17 3 24 14t5 22q-2 11-9.5 19T350-84q-123-18-196.5-110T80-408q0-65 30-129.5t75-123q45-58.5 97.5-110T380-862q5-4 10-6t10-2q5 0 10 2Zm-10 398Zm192 310H488v56q0 10-7 17t-17 7q-10 0-17-7t-7-17v-194q0-9 7-15.5t16-6.5h129q20 0 34 14t14 34v64q0 20-14 34t-34 14Zm134-23v79q0 10-7 17t-17 7q-10 0-17-7t-7-17v-192q0-10 7-17t17-7q10 0 17 7t7 17v65h108v-65q0-10 7-17t17-7q10 0 17 7t7 17v192q0 10-7 17t-17 7q-10 0-17-7t-7-17v-79H726Zm-238-25h104v-64H488v64Z"
		/>
	</svg>
);
